/**
 * EventSource cannot send Authorization headers.
 * Append access_token as a query param for authenticated SSE connections.
 */
export function withSseAccessToken(url: string): string {
  const token = localStorage.getItem('access_token');
  if (!token) {
    return url;
  }

  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}access_token=${encodeURIComponent(token)}`;
}
